<script lang="ts">
  import { setContext } from 'svelte';
  import { tabsContextKey, type TabsContext, type TabsProps } from './types';

  const { tabs, panels, action = () => undefined, actionArg }: TabsProps = $props();
  let activeTab = $state(1);
  let previousTab = $state<number | undefined>(undefined);
  const context: TabsContext = {
    activeTab: () => activeTab,
    previousTab: () => previousTab,
    setActiveTab: (tab) => {
      previousTab = activeTab;
      activeTab = tab;
    },
    renderedTabPanels: 0,
    renderedTabs: 0,
    panelId: (tabNumber) => context.id + '-panel-' + tabNumber,
    tabId: (tabNumber) => context.id + '-tab-' + tabNumber,
    id: 'tabs', // TODO: This needs to be unique on a page, the value must be different if multiple tabs exist on a page
  };
  setContext(tabsContextKey, context);

  function onKeydown(e: KeyboardEvent) {
    let newTab: number | undefined = undefined;
    if (e.key === 'ArrowRight') {
      newTab = context.activeTab() + 1;
    } else if (e.key === 'ArrowLeft') {
      newTab = context.activeTab() - 1;
    }
    if (newTab !== undefined && newTab > 0 && newTab <= context.renderedTabs) {
      context.setActiveTab(newTab);
    }
  }

  function elementAction(node: HTMLDivElement) {
    if (action) {
      return action(node, actionArg!);
    }
  }
</script>

<div use:elementAction>
  <div
    class="relative flex items-end gap-8 border-b-[6px] border-solid border-st-gray-100"
    role="tablist"
    aria-label="Tabs"
    tabindex="0"
    onkeydown={onKeydown}
  >
    {@render tabs()}
  </div>
  <div class="px-gutter pt-gutter">
    {@render panels()}
  </div>
</div>
